import { ContactsResponse } from '@/types';
import { create } from 'zustand';

interface ContactsState {
  contacts: ContactsResponse | null;
  searchQuery: string;
  currentPage: number;
  setContacts: (contacts: ContactsResponse) => void;
  setSearchQuery: (query: string) => void;
  setCurrentPage: (page: number) => void;
}

export const useContactsStore = create<ContactsState>((set) => ({
  contacts: null,
  searchQuery: '',
  currentPage: 1,
  setContacts: (contacts) => set({ contacts }),
  setSearchQuery: (query) => set({ searchQuery: query, currentPage: 1 }),
  setCurrentPage: (page) => set({ currentPage: page }),
}));
